import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommonService {
  private subjectName = new Subject<any>();
  private positionChanged = new Subject<boolean>();
  private keyBoardSize = new Subject<number>();
  private isDrawTool = new Subject<boolean>();
  private showExtraToolTip = new Subject<boolean>();
  private isTabbingOn = new Subject<boolean>();
  private allowNotifications = new Subject<boolean>();
  private canvasBackgroundColor = new Subject<string>();

  setCanvasBackgroundColor(color: string) {
    this.canvasBackgroundColor.next(color);
  }

  getCanvasBackgroundColor(): Observable<any> {
    return this.canvasBackgroundColor.asObservable();
  }

  sendUpdate(isPreferences: boolean) {
    this.subjectName.next(isPreferences);
  }

  getUpdate(): Observable<any> {
    return this.subjectName.asObservable();
  }

  setAllowNotifications(state: boolean) {
    this.allowNotifications.next(state);
  }

  getAllowNotifications() {
    return this.allowNotifications.asObservable();
  }

  getKeyboardPosition() {
    return this.positionChanged.asObservable();
  }

  setKeyboardPosition(data: boolean) {
    this.positionChanged.next(data);
  }

  getShowExtraToolTip() {
    return this.showExtraToolTip.asObservable();
  }
  setShowExtraToolTip(data: boolean) {
    this.showExtraToolTip.next(data);
  }
  getIsTabbingOn() {
    return this.isTabbingOn.asObservable();
  }
  setIsTabbingOn(data: boolean) {
    this.isTabbingOn.next(data);
  }

  getKeyboardSize() {
    return this.keyBoardSize.asObservable();
  }

  setKeyboardSize(data: number) {
    this.keyBoardSize.next(data);
  }

  getDrawToolSelected() {
    return this.isDrawTool.asObservable();
  }

  setDrawToolSelected(data: boolean) {
    this.isDrawTool.next(data);
  }
}
